export const VIDEO_TYPES = {
  VOD: 'VOD',
  LIVE: 'LIVE',
}
